import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useSiteConfig } from "../config/SiteConfigContext";
import { useIsMobile } from "../hooks/useIsMobile";
import { PRIVACY_POLICY } from "../content/privacyPolicy";

// Pagina Privacy Policy custom (sostituisce il link esterno Iubenda).
// Contenuto statico multilingua reso nel design del sito. La palette/font
// arrivano dalle CSS custom properties impostate su :root da SiteConfigProvider.

const BACK_LABEL: Record<string, string> = {
  it: "Torna alla home",
  en: "Back to home",
  de: "Zurück zur Startseite",
};

const PRIVACY_CSS = `
.pp-overline { font-size: 11px; font-weight: 600; letter-spacing: 3px; text-transform: uppercase; color: var(--color-accent); margin-bottom: 18px; }
.pp-body { color: rgba(28,75,59,0.86); font-family: var(--font-body); font-size: 15px; line-height: 1.85; }
.pp-body h1 { font-family: var(--font-heading); font-weight: 400; font-size: clamp(28px, 5vw, 44px); color: var(--color-dark); line-height: 1.15; letter-spacing: -0.5px; margin: 0 0 12px; }
.pp-body .pp-sub { font-size: 14px; color: var(--color-muted); margin: 0 0 8px; font-style: italic; }
.pp-body h2 { font-family: var(--font-heading); font-weight: 400; font-size: clamp(20px, 3.4vw, 27px); color: var(--color-dark); line-height: 1.25; letter-spacing: -0.3px; margin: 48px 0 16px; padding-top: 26px; border-top: 1px solid rgba(28,75,59,0.10); }
.pp-body h3 { font-family: var(--font-heading); font-weight: 400; font-size: 18px; color: var(--color-dark); margin: 28px 0 10px; }
.pp-body p { margin: 0 0 14px; }
.pp-body ul { margin: 0 0 16px; padding-left: 20px; }
.pp-body li { margin-bottom: 10px; }
.pp-body .pp-purpose { border: 1px solid rgba(28,75,59,0.12); border-left: 3px solid var(--color-accent); border-radius: 8px; padding: 18px 20px; margin: 0 0 16px; background: rgba(0,0,0,0.015); }
.pp-body .pp-purpose .pp-lead { font-weight: 600; color: var(--color-dark); margin: 0 0 12px; }
.pp-body .pp-field { display: grid; grid-template-columns: 200px 1fr; gap: 16px; padding: 12px 0; border-top: 1px solid rgba(28,75,59,0.08); }
.pp-body .pp-flabel { font-size: 11px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: var(--color-muted); padding-top: 2px; }
.pp-body .pp-updated { margin-top: 34px; font-size: 13px; color: var(--color-muted); font-style: italic; }
.pp-back { display: inline-block; margin-top: 48px; color: var(--color-muted); font-size: 13px; font-weight: 500; text-decoration: none; letter-spacing: 0.3px; transition: color 0.2s; }
.pp-back:hover { color: var(--color-dark); }
@media (max-width: 640px) {
  .pp-body .pp-field { grid-template-columns: 1fr; gap: 4px; }
  .pp-body .pp-flabel { padding-top: 8px; }
}
`;

export function Privacy() {
  const { locale } = useParams();
  const cfg = useSiteConfig();
  const isMobile = useIsMobile();

  const lang = locale && PRIVACY_POLICY[locale] ? locale : "it";
  const html = PRIVACY_POLICY[lang];
  const backLabel = BACK_LABEL[lang] ?? BACK_LABEL.it;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [lang]);

  return (
    <div style={{ background: cfg.color_body_bg, minHeight: "60vh" }}>
      <style>{PRIVACY_CSS}</style>
      <div style={{ maxWidth: 860, margin: "0 auto", padding: isMobile ? "56px 22px 80px" : "96px 32px 120px" }}>
        <div className="pp-overline">{cfg.brand_name}</div>
        <div className="pp-body" dangerouslySetInnerHTML={{ __html: html }} />
        <Link to={`/${locale || "it"}`} className="pp-back">&larr; {backLabel}</Link>
      </div>
    </div>
  );
}
